import Crypto from 'crypto-js';
import axios from 'axios';
import Session from './helpers/session';
import logger from './helpers/logger';

const session = Session();

function getUserFromLocal() {
  const aes = window.localStorage.getItem('wp-user');
  let decrypt = [];

  if (!aes) return null;
  decrypt = Crypto.AES.decrypt(atob(aes), process.env.VUE_APP_SECRET);
  return JSON.parse(decrypt.toString(Crypto.enc.Utf8));
}

function tick() {
  session.check();
}

function setAxiosInterceptors(store, router) {
  axios.interceptors.response.use(
    res => res,
    (err) => {
      if (
        store.state.IsLogged
        && window._.get(err, 'response.status') === 401
      ) {
        store.commit('LOGOUT');
        router.push({ name: 'login' });
      }

      return Promise.reject(err);
    },
  );
}

export default async (store, router, fn) => {
  const user = getUserFromLocal();

  ({ data: window.ENV } = await axios.get('/env.json'));
  axios.defaults.baseURL = process.env.VUE_APP_API;
  session.set(user);

  // Setup third party, external or local libraries/scripts.
  setInterval(tick, 1000);
  setAxiosInterceptors(store, router);
  logger.setMode();
  logger.executeQueue();

  fn(user);
};
